import React, { Component, useRef } from "react";
import { makeStyles, withStyles, useTheme, styled } from '@material-ui/core/styles';
import Save from '../../../../../../assets/img/svg/save.svg';
import Cancel from '../../../../../../assets/img/svg/cancel.svg';
import Delete from '../../../../../../assets/img/svg/delete.svg';
import docIcon from '../../../../../../assets/img/svg/docIcon.svg';
import image from '../../../../../../assets/img/svg/Image.svg';
import {
    TextField, FormControlLabel, Radio, Checkbox,
    Select, MenuItem, InputBase, Chip, Input, Button, InputAdornment,
    IconButton, FormHelperText, FormControl, RadioGroup
} from '@material-ui/core';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import Autocomplete from "react-autocomplete"
import { useNavigate } from "react-router-dom";
import withRouter from "../../../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import styles from "../../../../../../assets/jss/customStyle";
import $ from "jquery";
import axios from "axios";
import API from "../../../../../../_helpers/endpointService";
import { getlookupdocinfo } from "../../../../../../actions/MasterDataAction";
import del from "../../../../../../assets/img/svg/Del.svg"

const useStyles = makeStyles((theme) => ({
    root: {
        boxShadow: "none !important"
    },
    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
    },
    indicator: {
        backgroundColor: "#00838F",
    },
}));

const CheckboxWithBlackCheck = withStyles({
    root: {
        "& .MuiSvgIcon-root": {
            fill: "#FFFFFF",
            width: 20,
            height: 20,
            border: "1px solid #000000",
            "&:hover": {
                backgroundColor: "#FFFFFF"
            }
        },
        "&$checked": {
            "& .MuiIconButton-label": {
                position: "relative",
                zIndex: 0,
                backgroundColor: "#FFFFFF",
            },
            "& .MuiIconButton-label:after": {
                content: '""',
                height: 10,
                width: 10,
                position: "absolute",
                backgroundColor: "#000000",
                zIndex: -1
            }
        }
    },
    checked: {}
})(Checkbox);

const BootstrapError = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #f44336',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const names = [
    'Oliver Hansen',
    'Van Henry',
    'April Tucker',
    'Ralph Hubbard',
];

function getStyles(name, personName, theme) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}

class AddNewSd extends Component {
    constructor(props) {
        super(props);
        this.inputFile = React.createRef();
        this.state = {
            isMobile: false,
            state: {
                checkedA: true,
                checkedB: false,
            },
            isError: false,
            cancel: false,
            radio: 'sample',
            ProjectId: 0,
            SectionDivision: [],
            searchData: {
                ProjectId: 0,
            },
            Error: {
                BlockNo: false,
                SectionNumber: false,
                Sectiontype: false,
            },
            addData: {
                ProjectId: 0,
                Id: 0,
                BlockNo: "",
                DismantlingBlockPlanId: 0,
                SectionNumber: "",
                Sectiontype: "",
            },
            LookUP: {
                Name: "Block",
                PageNumber: 1,
                PageSize: 10,
            }
        }
    }
    handleInputChange = (e, str) => {
        this.state.cancel = true
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.addData[str] = e.target.value;
        this.setState({})
    };
    handleSelectChange = (e, id, block) => {
        this.state.cancel = true
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.addData[id] = parseInt(e.target.value);
        this.state.addData[block] = e.target.options[e.target.selectedIndex].text
        this.setState({})
       
    }
    componentDidMount() {
        const { dispatch } = this.props;
        this.state.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.searchData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.setState({})
        this.dataTable(this.state.searchData.ProjectId)
        window.location.pathname == '/dismantlingplan/edit' ? this.setState({ isView: false }) : this.setState({ isView: false })
        window.addEventListener("resize", this.resize.bind(this));
        this.resize()
        this.interval = setInterval(() => {
            this.resize1()
        }, 10);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
        window.removeEventListener("resize", this.resize.bind(this));
        $("#SEC1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Dissecdiv1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Dissecdiv").addClass("d-none");
        $("#Dissecdiv").removeClass("d-block");
        $("#SDL").removeClass("active-color");
        $("#SDT").removeClass("fw-bolder");
    }
    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            this.props.navigate("/sidebar");
        }

    };
    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        this.props.navigate("/sidebar");
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }


    };
    resize1 = () => {
        $("#SEC1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Dissecdiv1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Dissecdiv").removeClass("d-none");
        $("#Dissecdiv").addClass("d-block");
        $("#SDL").addClass("active-color");
        $("#SDT").addClass("fw-bolder");
    }
    dataTable = (id) => {

        let apiUrl = API.BLOCK + 'DismantlingPlan/List/BlockPlan?projectId=' + id
       
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.dispatch({ type: "SD_BLOCKNO", data: response.data });
                    this.setState({
                        SectionDivision: response.data,
                    })
                }
                else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
            });
    }
    addSD = (data) => {
        let apiUrl = API.BLOCK_DIVISION;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (response?.status === 200) {
                    this.props.navigate("/dismantlingplan/sectiondivision")

                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };
    AddCancel1 = () => {
        this.props.dispatch({ type: "SD", data: true })
        if (this.state.cancel == true) {
            window.$("#cancelpopup").modal("show");
        }
        else {
            this.props.dispatch({ type: "CANCEL", data: false });
            this.props.navigate(`/dismantlingplan/sectiondivision`)
        }
    }
    AddCancel = () => {
        this.props.dispatch({ type: "SD", data: true })
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup").modal("hide");
        this.props.navigate("/dismantlingplan/sectiondivision")
    }
    AddSave = () => {
        this.props.dispatch({ type: "SD", data: true })
        if (this.state.addData.BlockNo == ""||this.state.addData.BlockNo==="Select Status") {
            this.state.Error.BlockNo = true;
            this.setState({})
        }
        else {
            this.state.Error.BlockNo = false;
            this.setState({})
        }
        if (this.state.addData.SectionNumber.trim() == "") {
            this.state.Error.SectionNumber = true;
            this.state.addData.SectionNumber = this.state.addData.SectionNumber.trim();
            this.setState({})
        }
        else {
            this.state.Error.SectionNumber = false;
            this.state.addData.SectionNumber = this.state.addData.SectionNumber.trim();
            this.setState({})
        }
        if (this.state.addData.Sectiontype == "") {
            this.state.Error.Sectiontype = true;
            this.setState({})
        }
        else {
            this.state.Error.Sectiontype = false;
            this.setState({})
        }
        if (this.state.addData.Sectiontype != '' && this.state.addData.SectionNumber != '' && this.state.Error.BlockNo == false) {
            this.props.dispatch({ type: "CANCEL", data: false });
            this.addSD(this.state.addData)
        }
    }
    render() {
        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"SEC" + "1"} className='  textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="SEC" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5">
                                    <h4>Add New Section</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isMobile ? <table className="dataTable border-top" width="100%">
                        <tbody>
                            <tr>
                                <td className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                <td className="border-right text-center">
                                    <button className={classes.button} onClick={this.AddSave}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                </td>
                                <td className="text-center">
                                    <button className={classes.button} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                        : <table className="dataTable" width="100%">
                            <tbody>
                                <tr>
                                    <td width="5%" className="border-right text-center">
                                        <i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                    <td width="95%">
                                        <button className={`${classes.button}`} onClick={this.AddSave} ><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                        <button className={`${classes.button} pl-3`} onClick={this.AddCancel1} ><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>}
                    <div style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        {this.state.isMobile ? "" : <h6 className="col-12 mx-2 mt-3 ml-1">Add New Section</h6>}
                        <div className={this.state.isMobile ? "row mt-1 mx-0 pr-2 pt-1" : "row mt-1 mx-3 pr-2 pt-1"}>
                            <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>

                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 mt-2 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "pt-2 d-flex" : "float-end d-flex text-right m-0"}>Block Number&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div></label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {this.state.Error.BlockNo ?
                                        <select className="form-control border-radius"
                                            onChange={(e) => { this.handleSelectChange(e, "DismantlingBlockPlanId", "BlockNo") }}
                                            value={this.state.addData.DismantlingBlockPlanId}
                                            style={{ borderColor: "red" }}
                                        >
                                            <option value={0}>Select Status</option>
                                            {this.state.SectionDivision && this.state.SectionDivision?.map((item, index) => (
                                                <option value={item.Id}>{item.BlockNo}</option>
                                            ))}
                                        </select> :
                                        <select className="form-control border-radius"
                                            onChange={(e) => { this.handleSelectChange(e, "DismantlingBlockPlanId", "BlockNo") }}
                                            value={this.state.addData.DismantlingBlockPlanId}
                                        >
                                            <option value={0}>Select Status</option>
                                            {this.state.SectionDivision && this.state.SectionDivision?.map((item, index) => (
                                                <option value={item.Id}>{item.BlockNo}</option>
                                            ))}
                                        </select>}
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "pt-2 d-flex" : "float-end d-flex text-right m-0"}>Section Number&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div></label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {this.state.Error.SectionNumber ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={this.state.addData.SectionNumber}
                                            onChange={(e) => { this.handleInputChange(e, "SectionNumber") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}

                                        />
                                        :
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData.SectionNumber}
                                            onChange={(e) => { this.handleInputChange(e, "SectionNumber") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                    }


                                </div>

                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "pt-2 d-flex" : "float-end d-flex text-right"}>Section Type&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div></label>
                                </div>
                                <div className={`col-12 col-sm-12 col-xl-11 col-lg-10  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-10 pt-4 pb-4"}`}>
                                    {this.state.Error.Sectiontype ? <>
                                        <RadioGroup row aria-label="gender" value={this.state.addData.Sectiontype} onChange={(e) => { this.handleInputChange(e, "Sectiontype") }} fullWidth className={classes.error}>
                                            <FormControlLabel value="Port" control={<Radio color="default" className={classes.error} />} label="Port" size="small" />
                                            <FormControlLabel value="STBD" control={<Radio color="default" className={classes.error} />} label="STBD" size="small" />
                                            <FormControlLabel value="Center" control={<Radio color="default" className={classes.error} />} label="Center" size="small" />
                                            <FormControlLabel value="Center_Port" control={<Radio color="default" className={classes.error} />} label="Center Port" size="small" />
                                            <FormControlLabel value="Center_STBD" control={<Radio color="default" className={classes.error} />} label="Center STBD" size="small" />
                                        </RadioGroup>
                                    </> :
                                        <RadioGroup row aria-label="gender" value={this.state.addData.Sectiontype} onChange={(e) => { this.handleInputChange(e, "Sectiontype") }} fullWidth >
                                            <FormControlLabel value="Port" control={<Radio color="default" />} label="Port" size="small" />
                                            <FormControlLabel value="STBD" control={<Radio color="default" />} label="STBD" size="small" />
                                            <FormControlLabel value="Center" control={<Radio color="default" />} label="Center" size="small" />
                                            <FormControlLabel value="Center_Port" control={<Radio color="default" />} label="Center Port" size="small" />
                                            <FormControlLabel value="Center_STBD" control={<Radio color="default" />} label="Center STBD" size="small" />
                                        </RadioGroup>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.AddCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" onClick={() => window.$("#cancelpopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        Lookup_data: state.MasterDataReducer.Lookup_data || [],
        SD_BlockNumber: state.SectionDivisionReducer.SD_BlockNumber || [],
    };
}

AddNewSd.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddNewSd))
);
